import { useMemo } from 'react';
import { isRenderFunction } from 'utils/react';
import { BreakpointConfig, UseElementBreakpointComponentProps } from './types';
import useElementBreakpoints from './useElementBreakpoints';

// creates a breakpoint by monitoring an element's size as opposed to the browser's size
export default function useElementBreakpoint(config: BreakpointConfig) {
  const { ref, matches } = useElementBreakpoints({
    breakpoint: config,
  });

  // TOOD change this implementation.  component will change every time isWithinRange changes.
  // use context to get isWithinRange down to component without causing changes to the component.
  // also, add some way to render the "no match" case
  const Component: React.FC<UseElementBreakpointComponentProps> = useMemo(
    () =>
      ({ children }) => {
        if (matches.breakpoint) {
          return <>{isRenderFunction(children) ? children() : children}</>;
        }
        return null;
      },
    [matches.breakpoint],
  );

  return {
    Component,
    matches: matches.breakpoint,
    ref,
  };
}
